import {queries} from '@/shared/integrations/zero'
import {Anchor, createTopAnchor} from '@cypro/ui/components/ui/infinite-data-table'
import {useQuery} from '@rocicorp/zero/react'
import {ListPrescribedNamesInput} from '@cypro/engine/queries'
import {useEffect, useMemo, useState} from 'react'
import {PrescribedName} from '@cypro/engine/schema'

export function useGetPrescribedNames({
  sort = {dir: 'asc', field: 'name'},
  filters,
  limit,
}: Omit<Partial<ListPrescribedNamesInput>, 'cursor'> = {}) {
  const [anchor, setAnchor] = useState<Anchor<PrescribedName>>(createTopAnchor<PrescribedName>())

  const cursor =
    anchor.startRow?.id && anchor.startRow?.createdAt
      ? {
          id: anchor.startRow.id,
          direction: anchor.direction,
          createdAt: anchor.startRow.createdAt,
          name: anchor.startRow.name,
        }
      : undefined

  const query = queries.products.listPrescribedNames({
    cursor,
    sort,
    filters,
    limit,
  })
  const [prescribedNames, meta] = useQuery(query)

  const filtersHash = useMemo(() => JSON.stringify(filters), [filters])
  useEffect(() => {
    setAnchor(createTopAnchor<PrescribedName>())
  }, [sort?.dir, sort?.field, filtersHash, limit])

  return {
    query,
    meta,
    prescribedNames,
    anchor,
    fetchMore: setAnchor,
    canFetchMore: prescribedNames.length === limit,
    isFetching: meta.type === 'unknown',
  }
}
